import type { TextTrackCustomSettings } from '../text-track-custom-settings'

import { Events } from '|>/shared/events'
import { li, span } from '|>/shared/h'
import { register } from '|>/shared/vjs'
import { BaseMenuItem } from '../../../base'
import {
  getTextTrackCustomSettings,
  updateTextTrackCustomSettings,
} from '../text-track-custom-settings'

/**
 * Interface for any component that can trigger events
 */
interface IEventContainer {
  trigger(event: string, data?: any): void
}

/**
 * Settings custom menu item for text track settings
 * Handles selection and updates of individual settings
 */
@register
export class SettingsCustomMenuItem extends BaseMenuItem {
  declare options_: any
  declare container: IEventContainer | undefined
  declare labelEl_: HTMLSpanElement
  declare parentMenu: any // Parent menu that contains this item

  override createEl() {
    return li('.vjs-menu-item.vjs-x-menu-subtitles-nested-item', [
      (this.labelEl_ = span('', this.localize(this.options_.value))),
    ])
  }

  override handleClick() {
    const { settingKey, settingValue } = this.options_

    if (settingKey && settingValue !== undefined) {
      // Get current settings
      const currentSettings = getTextTrackCustomSettings()

      // Update specific setting
      const updates = {
        [settingKey]: settingValue,
      } as Partial<TextTrackCustomSettings>
      const updatedSettings = updateTextTrackCustomSettings(
        currentSettings,
        updates
      )

      // Trigger event for player to update classes
      this.player_.trigger(
        Events.TextTrack.CustomSettingsUpdated,
        updatedSettings
      )

      // Update visual state
      if (this.parentMenu?.update) {
        this.parentMenu.update()
      }

      // Navigate back to custom menu immediately
      if (this.options_.back) {
        this.container?.trigger(this.options_.back)
      }
    }
  }

  update() {
    const { settingKey, settingValue } = this.options_

    if (settingKey && settingValue !== undefined) {
      const currentSettings = getTextTrackCustomSettings()
      const currentValue =
        currentSettings[settingKey as keyof TextTrackCustomSettings]
      const isSelected = currentValue === settingValue

      if (isSelected) {
        this.addClass('vjs-selected')
      } else {
        this.removeClass('vjs-selected')
      }
    }
  }
}

SettingsCustomMenuItem.options = {
  value: 'default',
  settingKey: '',
  settingValue: '',
}
